import React from 'react';
import PropTypes from 'prop-types';
import { RightSideBar } from '../../../../../../newContainers';
import { ScrollWrapper, TabWrapper } from '../../../../../../ui-kit';
import ClientsSummary from '../clientsSummary';
import PinnedClients from '../pinnedClients';
import { TabWrapperMobile } from '../../../../../../newContainers/rightSideBar/components';
import './style.sass';

const RightSideBarContainer = ({
  t, setActiveTabTitle, activeTabTitle,
}) => (
  <>
    <RightSideBar className="right-side-bar--clients" title={t('Clients summary')}>
      <ScrollWrapper className="right-side-bar__scroll-wrapper">
        <ClientsSummary />
        <TabWrapper
          title={<h2 className="title">Pinned clients</h2>}
        >
          <PinnedClients />
        </TabWrapper>
      </ScrollWrapper>
      <ScrollWrapper className="right-side-bar__scroll-wrapper">
        <ClientsSummary />
        <TabWrapperMobile
          setActiveTitle={setActiveTabTitle}
          title="Pinned clients"
          active={activeTabTitle}
        >
          <PinnedClients />
        </TabWrapperMobile>
      </ScrollWrapper>
    </RightSideBar>
  </>
);

RightSideBarContainer.propTypes = {
  windowWidth: PropTypes.number.isRequired,
  activeTabTitle: PropTypes.string,
  t: PropTypes.func.isRequired,
  setActiveTabTitle: PropTypes.func.isRequired,
};
RightSideBarContainer.defaultProps = {
  activeTabTitle: '',
};

export default RightSideBarContainer;
